<template>
  <Modal id="add-new-grid-stack" :title="title" class="grid-stack-create-form" @submit="submit">
    <template v-slot:body>
      <div class="position-relative row general pt-2">
        <div class="col-6 mb-2 check-container" v-for="(object, key) in components" :key="key">
          <input :id="`modal-item-${key}`" type="radio" :value="key" v-model="component" />
          <label :for="`modal-item-${key}`" :class="`card modal-item p-2 checkmark ${key}`">
            <div class="font-weight-bolder">{{ object.label }}</div>
            <small>{{ object.description || '&nbsp;' }}</small>
          </label>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      component: ''
    }
  },
  computed: {
    title() {
      return 'Add Component'
    },
    components() {
      return this.config?.data
    }
  },
  methods: {
    submit() {
      if (this.component) {
        if (this.config?.callback) this.config?.callback({ component: this.component, components: this.components })
      }
      this.$emit('close')
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
#add-new-grid-stack {
  .modal-item {
    cursor: pointer;
    user-select: none;
  }
  input {
    display: none;
  }
  .check-container .modal-item {
    background: #f5f5f9;
  }
}
</style>
